// Translation: Model > Access key manager > Access key managing dialog > Access key information form (English)
export default Object.freeze({
	actions: {
		limit: 'Add time limit'
	},
	fields: {
		expirationDate: {
			label: 'Expiration date',
			helper: {
				default: 'Will expire at {{time}} (your time zone)',
				invalidDate: 'Invalid date',
				outOfRange: 'Out of range'
			}
		},
		name: {
			helper: 'Name is already used',
			label: 'Name',
			placeholder: 'Enter access key name'
		},
		type: {
			helper: 'Admin keys can be used for setting rate and usage limits via the SDK but cannot be used for inference.',
			label: 'Admin key'
		}
	}
})
